import { z } from "zod";

import type { Option } from "@/components/molecules/SelectOptions/BaseSelectOptions";

export const vibesSchema = z.object({
  tags: z.array(z.string()).min(1, "Please select at least one tag"),

  ambiance: z
    .array(z.string())
    .min(1, "Please select at least one ambiance option"),

  dressCode: z
    .array(z.string())
    .min(1, "Please select at least one dress code"),

  moment: z.array(z.string()).min(1, "Please select at least one moment"),

  priceLevel: z
    .array(z.string())
    .min(1, "Please select at least one type of price"),
});

export type BrandVibesType = z.infer<typeof vibesSchema>;

export type FieldName = keyof BrandVibesType;

export type VibesType = {
  title: string;
  list: Option[];
  name: FieldName;
};

export enum AverageWaitTime {
  UNDER_10_MIN = "<10 min",
  TEN_TO_20_MIN = "10-20 min",
  TWENTY_TO_30_MIN = "20-30 min",
  OVER_30_MIN = ">30 min",
}

export const averageTimeList = Object.values(AverageWaitTime);
